export default null;throw new Error("Unable to resolve \"../pkg\" from npm:lightningcss@1.21.0/node/index.js");